export default {
    document: "GEN",
    explore_all_our_universe_of_courses_videos_articles_and_exclusive_files: "Explore todo o nosso universo de cursos, vídeos, artigos e materiais exclusivos.",
    project_name: "Samsung SDS Academy",
    register: "GEN",
    welcome_to: "Bem-vindo(a) à ",
}